// Consolidates values for posting to API
export const formDataJson = (fields) => {
  let data = {}
  Object.keys(fields).forEach((key) => {
    data = {
      ...data,
      [key]: fields[key].value,
    }
  })
  return data
}
